module.exports = __webpack_public_path__ + "img/stores_virtuell_appointment@1x.061f95f.webp";